import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { PATH } from 'src/features/navigation/utils/constants';
import { displaySettingsMessages } from 'src/features/systems/utils/displaySettingsMessages';
import { GATEWAY_DISPLAY_MODEL } from 'src/features/systems/utils/types';
import {
    GeneralBlockHead,
    GeneralBlockHeader,
    GeneralBlockSubtitle,
    GeneralBlockTitle,
} from 'src/registry/components/blocks/GeneralBlock';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';
import { ICON_MAP } from 'src/utils/constants';

type DisplayChoice = {
    model: GATEWAY_DISPLAY_MODEL;
    titleMessage: typeof displaySettingsMessages.spDisplay;
    descriptionMessage: typeof displaySettingsMessages.spDisplayDescription;
};

const DISPLAY_CHOICES: DisplayChoice[] = [
    {
        model: GATEWAY_DISPLAY_MODEL.SP,
        titleMessage: displaySettingsMessages.spDisplay,
        descriptionMessage: displaySettingsMessages.spDisplayDescription,
    },
    {
        model: GATEWAY_DISPLAY_MODEL.HUIDU,
        titleMessage: displaySettingsMessages.huiduDisplay,
        descriptionMessage: displaySettingsMessages.huiduDisplayDescription,
    },
    {
        model: GATEWAY_DISPLAY_MODEL.NED200,
        titleMessage: displaySettingsMessages.ned200Display,
        descriptionMessage: displaySettingsMessages.ned200DisplayDescription,
    },
];

const DisplaySettings = () => {
    const { formatMessage } = useIntl();

    return (
        <SectionBlock>
            <SectionBlockHeader>
                <SectionBlockHead>
                    <SectionBlockTitle>{formatMessage(displaySettingsMessages.chooseDisplayType)}</SectionBlockTitle>
                    <SectionBlockSubtitle className="max-w-fit">
                        {formatMessage(displaySettingsMessages.chooseDisplayTypeDescription)}
                    </SectionBlockSubtitle>
                </SectionBlockHead>
            </SectionBlockHeader>
            <SectionBlockSeparator />
            <SectionBlockBody className="grid grid-cols-1 lg:grid-cols-2">
                {DISPLAY_CHOICES.map((choice) => (
                    <Button
                        key={choice.model}
                        asChild
                        variant="outline"
                        className="flex h-auto min-w-full cursor-pointer justify-start gap-4 rounded-xl border border-gray-200 bg-white p-4 text-left font-normal hover:bg-gray-100"
                    >
                        <Link to={`/${PATH.ADMINISTRATION}/display-settings/${choice.model}`}>
                            <GeneralBlockHeader>
                                <SquareIcon icon={ICON_MAP.MESSAGE} />
                                <GeneralBlockHead>
                                    <GeneralBlockTitle className="text-base text-gray-900">
                                        {formatMessage(choice.titleMessage)}
                                    </GeneralBlockTitle>
                                    <GeneralBlockSubtitle className="wrap-break-word whitespace-normal">
                                        {formatMessage(choice.descriptionMessage)}
                                    </GeneralBlockSubtitle>
                                </GeneralBlockHead>
                            </GeneralBlockHeader>
                        </Link>
                    </Button>
                ))}
            </SectionBlockBody>
        </SectionBlock>
    );
};

export default DisplaySettings;
